/* eslint-disable react/react-in-jsx-scope */
import { Disclosure, DisclosureButton, DisclosurePanel, Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { useUserContext, useUserDispatch } from '../contexts/UserContext';
import { useCarts } from '../contexts/CartContext';

import { Link, useNavigate } from "react-router"
import { Bars3Icon, BellIcon, XMarkIcon, ShoppingCartIcon, PresentationChartBarIcon  } from '@heroicons/react/24/outline'
import { 
    UserCircleIcon, 
    ChevronRightIcon, 
    ArrowRightCircleIcon,
    IdentificationIcon,
    ClipboardDocumentCheckIcon, 
    CurrencyDollarIcon, 
    HomeIcon,
    QrCodeIcon,
    DocumentTextIcon,
    TruckIcon ,
    DocumentChartBarIcon, 
    WalletIcon,
} from "@heroicons/react/16/solid";
  

const navigation = [
    { name: 'Home', href: '/', current: true },
    { name: 'Products', href: '/#sector1', current: false },
    { name: 'Shop', href: '/shop', current: false },
    // { name: 'Contact Us', href: 'user', current: false },
  ]

const AdminMenu = [
    { name: 'Dashboard', href: '/pos', icon: HomeIcon },
    {
        name: 'ยอดขาย',
        href: '/reports',
        icon: ShoppingCartIcon  ,
        },
        {
    name: 'รายรับ-รายจ่าย',
    href: '/income',
    icon: CurrencyDollarIcon ,
    },
    {
        name: 'ยอดสแกนจ่าย',
        href: '/scanpaid',
        icon: QrCodeIcon  ,
        },
        {
    name: 'Invoices',
    href: '/pos/invoices',
    icon: DocumentTextIcon ,
    },
];

const userNavigation = [
    { name: 'Profile', href: '/users/chpwd' },
    { name: 'Change Password', href: '/users/chpwd' },
    // { name: 'POS', href: 'pos' },
]

function CurrentUser() {
    const user = useUserContext();
    const cart = useCarts();

    const dispatch = useUserDispatch();
    const navigate = useNavigate();

    const handleLogout = () => {
        
        dispatch({
            type: 'logout',
          });

          navigate("/login");    
      }

    function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
    }
      
    const cartItems = cart.reduce((sum, item) => sum + item.quantity, 0);

    // console.log(cartItems);

    return (
        <>
            <div className="flex items-center justify-between px-2 ">
               <Link to="/cuscart" className="flex px-2">
                    <PresentationChartBarIcon  className="h-6 w-6 text-slate-600 hover:text-yellow-300 " />
                    {/* {user.notice>0 && 
                        <span className="relative text-center text-xs text-white justify-center items-center  -top-1 -left-2 bg-red-600 w-4 h-4 rounded-full   ">
                            {user.notice}
                        </span>
                    } */}
                </Link>
                <Link to="#" className="flex px-2">
                    <BellIcon className="h-6 w-6 text-slate-600 hover:text-blue-300 " />
                    {user.notice>0 && 
                        <span className="relative text-center text-xs text-white justify-center items-center  -top-1 -left-2 bg-red-600 w-4 h-4 rounded-full   ">
                            {user.notice}
                        </span>
                    }
                </Link>
                 <Link to={user?.isLogin? "/pos/products" : "/checkout"} className="flex px-2">
                    <ShoppingCartIcon className={cart.length>0 ? "h-6 w-6 text-lime-600 hover:text-lime-300" : "h-6 w-6 text-slate-600"} />
                    {cart.length>0 && 
                        <span className="relative text-center text-xs text-white justify-center items-center  -top-1 -left-2 bg-red-600 w-4 h-4 rounded-full   ">
                            {/* {cart.length} */}
                            {cartItems}
                        </span>
                    }
                </Link>
                    {user?.isLogin? (
                        <Menu as="div">
                            {/* <div> */}
                                <MenuButton className="flex  items-center">
                                    <div className="flex w-10 h-10 rounded-full hover:shadow-md hover:shadow-teal-400 ">
                                        <img 
                                            src={`${process.env.REACT_APP_URL}/image/users/${user.user?.Avatar}`} 
                                            alt={user.user?.name}
                                            className="rounded-full" />
                                    </div>  
                                    {/* {user?.notice>0 && 
                                        <span className="text-center text-xs text-white justify-center items-center relative -top-2 -left-2 bg-red-600 w-4 h-4 rounded-full   ">
                                            {user.notice}
                                        </span>
                                    } */}
                                
                                </MenuButton>
                            {/* </div> */}
                            <MenuItems
                                transition
                                className="absolute right-14 md:right-4 z-40 p-2 mt-2 w-56 origin-top-right rounded-md text-gray-300 bg-slate-800  py-1 shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                            >
                                <div className="flex items-center px-5 py-2 border-b-2 border-slate-600">
                                    <div className="shrink-0">
                                        <img alt="" src={`${process.env.REACT_APP_URL}/image/users/${user.user?.Avatar}`}  className="size-10 rounded-full" />
                                    </div>
                                    <div className="ml-3">
                                        <div className="text-base/5 font-medium text-white">{user.user?.name}</div>
                                        <div className="text-sm font-medium text-gray-400">{user.user?.email}</div>
                                    </div> 
                                </div>
                                {user.user?.isAdmin==1 && AdminMenu.map((item) => {
                                    const LinkIcon = item.icon;
                                    return (
                                        <MenuItem key={item.name} >
                                            <Link
                                                to={item.href}
                                                className="block px-4 py-2 text-sm text-start data-[focus]:bg-gray-500 data-[focus]:outline-none rounded-xl"
                                            >
                                                <LinkIcon className="inline-block w-4 mr-2" />
                                                {item.name}
                                            </Link>
                                        </MenuItem>
                                    )
                                })}
                                <hr className="my-2 border-b border-slate-600" />
                                {userNavigation.map((item) => (
                                    <MenuItem key={item.name}>
                                        <Link
                                            to={item.href}
                                            className="block px-4 py-2 text-sm text-start data-[focus]:bg-gray-500 data-[focus]:outline-none rounded-xl"
                                        >
                                            {item.name}
                                        </Link>
                                    </MenuItem>
                                ))}
                                    <MenuItem key="logout">
                                        <button 
                                            onClick={handleLogout}
                                            className="px-4 mt-2 py-1 w-full rounded-lg bg-cyan-700   text-slate-300 hover:bg-red-500 ">
                                            Logout
                                        </button>
                                    </MenuItem>

                            </MenuItems>

                        </Menu>

                    ) : (
                        <div className="hidden md:flex items-center justify-center text-sm p-2">
                                <Link to="/login" className="px-2 mr-4 py-1 rounded-lg bg-blue-600 text-slate-300 hover:bg-blue-500 ">Login</Link>
                                <Link to="/register" className="px-2 py-1 rounded-lg bg-green-600 text-slate-300 hover:bg-green-700">Register</Link>
                        </div>
                    )}
               
                        {/* <div className="hiden md:flex   ">
                            <button 
                                onClick={handleLogout}
                                className="btnpx-4 mr-4 py-1 rounded-lg bg-red-800   text-slate-300 hover:bg-red-500 ">
                                logout
                            </button>
                        </div> */}

                    {/* </div> */}

               
            </div>

            {/* Mobile menu button */}
            {!user?.isLogin && (
                <Disclosure as="nav" className="flex md:hidden z-30">
                    {/* <div className="mx-auto px-6 lg:px-8"> */}
                        <div className="flex h-16 items-center justify-between">
                            <div className="flex items-center">
                            </div>
                            <div className=" flex md:hidden">
                                <DisclosureButton className="group relative inline-flex items-center justify-center rounded-md bg-gray-800 p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
                                    <span className="absolute -inset-0.5" />
                                    <span className="sr-only">Open main menu</span>
                                    <Bars3Icon aria-hidden="true" className="block size-6 group-data-[open]:hidden" />
                                    <XMarkIcon aria-hidden="true" className="hidden size-6 group-data-[open]:block" />
                                </DisclosureButton>
                            </div>
                        </div>
                    {/* </div> */}

                    <DisclosurePanel className="md:hidden absolute m-16 -left-16 py-0 px-0 z-30  justify-center  w-full">
                        <div className="py-6 px-4 z-50 rounded-xl bg-slate-700">
                            {navigation.map((item) => (
                                <DisclosureButton
                                    key={item.name}
                                    as="a"
                                    href={item.href}
                                    aria-current={item.current ? 'page' : undefined}
                                    className={classNames(
                                        item.current ? 'bg-gray-900 text-white' : 'text-gray-300 hover:bg-gray-800 hover:text-white',
                                        'block rounded-md px-3 py-2 text-base font-medium',
                                    )}
                                    >
                                    {item.name}
                                </DisclosureButton>
                            ))}
                            <div className="flex flex-wrap gap-2 items-center justify-start border-t-2 pt-2">
                                    <Link to="/login" className="px-4 mr-4 py-1 rounded-lg bg-blue-600 text-slate-300 hover:bg-blue-500 ">Login</Link>

                                    <Link to="/register" className=" px-4 py-1 rounded-lg bg-green-600 text-slate-300 hover:bg-green-700">Register</Link>
                        </div>
                        </div>
                    </DisclosurePanel>
                </Disclosure>
            )}
        </>
    )
}

export default CurrentUser